export default function BrandMark({ className = 'w-[20px] h-[24px]' }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" fill="none" className={className} aria-hidden="true">
      <path
        d="M4 2.5h8l-.6 10.2a1.5 1.5 0 0 1-1.5 1.4H6.1a1.5 1.5 0 0 1-1.5-1.4L4 2.5Z"
        fill="#2A1608"
      />
      <path d="M4.2 6.2h7.6" stroke="#E2461F" strokeWidth="1.5" />
    </svg>
  )
}
